import styled from 'styled-components';

export const DivFlex = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
